import { ChangeDetectorRef, Component, LOCALE_ID, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { Subscription } from "rxjs";
import { SharedModule } from "../../core/shared.module";
import { Utente } from "../../interfaces/user";
import { AppService } from "../../service/app.service";
import { LoaderService } from "../../service/loader.service";
import { NotificationService } from "../../service/notification.service";
import { tipologicaInterface } from "../../interfaces/tipologica.interface";
import { TabellaModificheComponent } from "../../shared/components/tabella-modifiche/tabella-modifiche.component";
import { MatSidenav } from "@angular/material/sidenav";
import { RisorseService } from "../../service/risorse.service";
import { Attori } from "../../shared/enum/attori.enum";
import { CurrentSort } from "../../interfaces/table.interface";
import { AnagraficaTimesheet } from "../../interfaces/timesheet.interface";
import { SelectionModel } from "@angular/cdk/collections";
import { LoadingModal } from "../../shared/components/loading-modal/loading.modal";
import { FiltroService } from "../../service/filtro.service";
import { Rettifica } from "../../interfaces/rettifica.interface";
import { FiltroModificheComponent } from "../../shared/components/filtro-modifiche/filtro-modifiche.component";
import { filtroRiepilogoModificheVuoto } from "../../interfaces/filtro-riepilogo-modifiche.interface";

@Component({
  selector: 'app-riepilogo-modifiche',
  standalone: true,
  imports: [
    SharedModule,
    NgxSkeletonLoaderModule,
    FiltroModificheComponent,
    TabellaModificheComponent
  ],
  templateUrl: './riepilogo-modifiche.component.html',
  providers: [{ provide: LOCALE_ID, useValue: 'it-IT' }],
})
export class RiepilogoModificheComponent {
  constructor(
    private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: MsalService,
    private appService: AppService,
    private dialog: MatDialog,
    private risorseService: RisorseService,
    private notificationService: NotificationService,
    private filtroService: FiltroService,
    private cd: ChangeDetectorRef,
  ) {}

  pageSubscriptions: Subscription = new Subscription();
  selection: SelectionModel<any> = new SelectionModel<any>(true, []);
  selectedData: any = [];
  componentLoaded = false;
  user = this.authService.instance.getAllAccounts()[0];
  utente: Utente = {};
  attore = this.appService.attore;
  attori = Attori;
  form: any = {};
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild(TabellaModificheComponent) tabellaModificheComponent!: TabellaModificheComponent;
  anagraficaTimesheet: AnagraficaTimesheet | null = null;
  elencoModifiche: Rettifica[] = [];
  elencoCount: number = 0;
  totalPages: number = 0;
  currentPage: number = 0;
  currentSort: CurrentSort = {
    flagAsc: true,
    orderBy: '',
  };
  pageOffset: number = 10;
  commesse: tipologicaInterface[] = [];
  uoPrimoLivello: tipologicaInterface[] = [];

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.elencoModifiche = data['data'].elencoModifiche;
      this.elencoCount = data['data'].elencoModificheCount;
      this.anagraficaTimesheet = data['data'].anagraficaTimesheet;
      this.commesse = data['data'].commesse;
      this.uoPrimoLivello = data['data'].uoPrimoLivello;
      this.totalPages = Math.ceil(this.elencoCount / this.pageOffset);
    });
    this.cd.detectChanges();
    this.componentLoaded = true;
    this.loader.hide();
  }

  iconClick(event: any) {
    if (event.columnDef === 'dettaglio') {
      this.risorseService.risorsa = {};
      this.risorseService.risorsa.nomeRisorsa = event.item.nomeRisorsa;
      this.risorseService.risorsa.risorsa = event.item.matricola;
      this.goToTimesheet();
    }
  }

  search(event: any) {
    this.form = event;
    this.sidenav.close();
    if (this.tabellaModificheComponent) {
      this.tabellaModificheComponent.handleSearchEvent(event);
    }
  }

  goToTimesheet(): void {
    this.loader.show();
    this.router.navigate([`dettaglio-risorsa`]);
  }

  goBack(): void {
    this.loader.show();
    this.router.navigate([`homepage`]);
  }

  masterSelection(event: any) {
    if (event) {
      this.selectedData = event.selected;
    }
  }

  exportDataToExcel(): void {
    const dialogRef = this.dialog.open(LoadingModal, {
      autoFocus: false,
      width: 'calc(100% - 30px)',
      maxWidth: '900px',
      disableClose: true,
    });
    this.tabellaModificheComponent.exportDataToExcel();
    dialogRef.close();
  }

  updateData(): void {
    this.tabellaModificheComponent.handleSearchEvent(filtroRiepilogoModificheVuoto);
  }

  ngOnDestroy(): void {
    this.pageSubscriptions.unsubscribe();
  }
}
